import { JsonObject, JsonProperty } from 'json2typescript';

import { Id } from './id';
import { IdAdapter } from '../../client/helpers/serializer/adapters/id.adapter';
import { QuestionOptionInterface } from '../../../core';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('QuestionOption')
export class QuestionOption implements QuestionOptionInterface {
    @JsonProperty('Id', IdAdapter, true)
    private _id: Id = undefined;

    @JsonProperty('Description', StringAdapter, true)
    private _description: string = undefined;

    @JsonProperty('Order', Number, true)
    private _order: number = undefined;

    private _selected = false;

    get id(): Id {
        return this._id;
    }

    get description(): string {
        return this._description;
    }

    get order(): number {
        return this._order;
    }

    get selected(): boolean {
        return this._selected;
    }

    set selected(value: boolean) {
        this._selected = value;
    }
}
